import React, { useEffect, useState } from "react";
import api from "../../api";
import { useLang } from "../../i18n";
import { useConfig } from "../../context/ConfigContext";
import { wsLabel } from "../../utils";
import BadgesGrid from "../../components/BadgesGrid";
import { SkeletonPanel } from "../../components/common";

export default function BadgesPage() {
  const { t, lang } = useLang();
  const { config } = useConfig();
  const [badges, setBadges] = useState(null);

  useEffect(() => {
    api.get("/badges").then((r) => setBadges(r.data.badges)).catch(() => setBadges([]));
  }, []);

  if (!badges) return <SkeletonPanel lines={5} />;
  const earned = badges.filter((b) => b.earned).length;

  return (
    <div className="max-w-3xl mx-auto space-y-6" data-testid="badges-page">
      <h2 className="text-2xl sm:text-3xl font-black text-center">{wsLabel(config?.ui_labels, "badges", lang, t("badges_page.title"))}</h2>
      <p className="text-center font-extrabold text-[#FFC83D]" data-testid="badges-earned-count">{earned} / {badges.length}</p>
      <div className="magic-panel p-6">
        <BadgesGrid badges={badges} asCard={false} />
      </div>
    </div>
  );
}
